import React from "react";
import {faPhone} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Colors} from "../../resources/Colors";

const ButtonCallTo = ({ tel, label }) => {
    const [over, setOver] = React.useState(false);

    return (
        <a href={tel}
           onMouseOver={() => setOver(true)}
           onMouseLeave={() => setOver(false)}
        > <FontAwesomeIcon icon={faPhone} color={over ? Colors.bioretisContrast  : Colors.white}/> {label} </a>
    );
};

export default ButtonCallTo;